import userReducer from './user';
const rootReducer = {
  user: userReducer,
};

export default rootReducer;
